<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="75px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="培训ID" )
                    el-input.inputWidth(v-model='dataForm.trainCode' clearable placeholder="请输入培训ID")
              el-col(:md='6' :sm="12")
                el-form-item(label="培训名称" )
                  el-input.inputWidth(v-model='dataForm.pxName' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方" )
                  el-select.inputWidth(v-model="dataForm.orgId",placeholder="请选择" filterable clearable )
                    el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
              el-col(:md='6' :sm="12")
                el-form-item(label="培训级别" )
                    el-select.inputWidth(v-model='dataForm.level' clearable )
                      el-option(v-for="(e, i) in pxLevel" :key="i" :label="e.label" :value="e.value")
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="状态" )
                    el-select.matchStatus.inputWidth(v-model='dataForm.state' clearable)
                      el-option(v-for='(e, i) in pxState' :key='i' :label="e.label" :value="e.value")
              el-col(:md='6' :sm="12")
                el-form-item(label="培训时间")
                    el-date-picker.inputWidth( style='width:210px;'  v-model='dataForm.pxTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle(null,1)' type='primary'  v-if="isAuth('px:single:add')" ) 新建培训
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(prop='trainCode',header-align='center',align='center',label='培训ID' width="160")
            el-table-column(prop='name',header-align='center',align='center',label='培训名称' width="150")
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='classCount',header-align='center',align='center',label='班级人数'  sortable )
                template(slot-scope="scope")
                    span() {{scope.row.joinCount}}/{{scope.row.classCount}}
            el-table-column(prop='level',header-align='center',align='center',label='培训级别' sortable )
            el-table-column(prop='trainStrDate',header-align='center',align='center',label='培训开始时间' width='160' sortable)
            el-table-column(prop='placesName',header-align='center',align='center',label='培训场馆')
            el-table-column(prop='coachName',header-align='center',align='center',label='教练' :show-overflow-tooltip='true')
            el-table-column(prop='state',header-align='center',align='center',label='状态' width="100")
                template(slot-scope="scope")
                    font(v-if='scope.row.state === 1')
                      span.danger()
                      span() &nbsp; 未审核
                    font(v-if='scope.row.state === 2')
                      span.warning()
                      span() &nbsp; 已拒绝
                    font(v-if='scope.row.state === 3')
                      span.success()
                      span() &nbsp; 已发布
                    font(v-if='scope.row.state === 4')
                      span.warning()
                      span() &nbsp; 报名中
                    font(v-if='scope.row.state === 5')
                      span.warning()
                      span() &nbsp; 报名结束
                    font(v-if='scope.row.state === 6' )
                      span.warning()
                      span() &nbsp; 已开训
                    font(v-if='scope.row.state === 7')
                      span.warning()
                      span() &nbsp; 已结束
                    font(v-if='scope.row.state === 8')
                      span.warning()
                      span() &nbsp; 已取消
            el-table-column(prop='recommend',header-align='center',align='center',label='首页推荐' width="100")
                template(slot-scope='scope')
                    font(v-if='scope.row.recommend == 0') 未推荐
                    font(v-if='scope.row.recommend == 1') 已推荐
            el-table-column(prop='byx1',header-align='center',align='center',label='备注')
                template(slot-scope="scope")
                    font(v-if='scope.row.state !== 8') {{scope.row.byx2}}
                    font(v-if='scope.row.state === 8') {{scope.row.byx1}}
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click="queryHandle(scope.row.id,1)" v-if="isAuth('px:single:detail')" ) 查看详情
                                el-menu-item(index="1-2" @click="addOrUpdateHandle(scope.row.id,2)"  type="text" v-if="(scope.row.state != 7 && scope.row.state != 8) && isAuth('px:single:update')" ) 修改培训
                                el-menu-item(index="1-3" @click='queryHandle(scope.row.id,2)' type='primary' v-if="scope.row.state == 1 && isAuth('px:single:apply')" ) 审核发布
                                el-menu-item(index="1-4" @click='releaseClick(scope.row,1)' type='primary' v-if="[3,4,5,6,7,8].indexOf(scope.row.state)>-1&&isAuth('px:single:userlist')" ) 培训人员管理
                                el-menu-item(index="1-12" @click='releaseClick(scope.row,4)' type='primary' v-if="[4,5,6].indexOf(scope.row.state)>-1&&isAuth('px:single:userlist')" ) 修改班级人数
                                el-menu-item(index="1-7" @click='releaseClick(scope.row,2)' type='primary' v-if="[3,4,5,6].indexOf(scope.row.state)>-1&& isAuth('px:single:reset')" ) 取消培训
                                el-menu-item(index="1-8" @click='releaseClick(scope.row,3)' type='primary' v-if="[3,4,5,6].indexOf(scope.row.state)>-1&& isAuth('px:single:over')" ) 结束培训
                                //- el-menu-item(index="1-8" @click='releaseClick(scope.row,3)' type='primary' v-if="scope.row.state == 6 && isAuth('px:single:over')" ) 结束培训
                                el-menu-item(index="1-9" @click='addOrUpdateHandle(scope.row.id,3)' type='primary'  v-if="isAuth('px:single:copy')" ) 复制并新建
                                el-menu-item(index="1-10" @click='recommend(scope.row.id,1)' type='primary'  v-if="scope.row.recommend == 0" ) 推荐
                                el-menu-item(index="1-11" @click='recommend(scope.row.id,0)' type='primary'  v-if="scope.row.recommend == 1" ) 取消推荐
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='queryList')
        //查看和审核
        queryView(v-if='queryViewVisible', ref="queryView",@refreshDataList='queryList')
        //培训人员管理
        elEnrollInfo(v-if='elEnrollInfoVisible',ref="elEnrollInfo",@refreshDataList='queryList')
        //- 取消培训
        el-dialog(title="请填写取消原因" :visible.sync="dialogFormVisible"  width='50%' :modal-append-to-body='false'  :close-on-click-modal='false' @close="cancelClose")
          el-form( ref="form" style='margin:0 auto;')
            el-form-item()
                el-input(type="textarea" :rows="5" resize="none" v-model="cancelReson")
            el-row(style='margin-top:30px;')
              el-col(align='center')
                el-button(type="primary" @click="cancelPx") 确认
                el-button(@click="dialogFormVisible=false" style='margin-left:50px;') 取消
        <updateClassCount ref="updateClassCount_ref" @confirm="getDataList" />
</template>

<script>
// import AddOrUpdate from "./add-or-update";
import AddOrUpdate from '../addOrUpdate'
// import QueryView from "./query-view";
import QueryView from '../queryView.vue'
import ElEnrollInfo from './el-enroll-info'
import commonData from '../common.js'
import updateClassCount from '../updateClassCount.vue'

export default {
  name: 'train-single',
  data () {
    return {
      pxLevel: commonData.pxLevel,
      pxState: commonData.pxState,
      dataForm: {
        trainCode: '',
        pxName: '',
        orgId: '',
        level: '',
        state: '', //状态(1:未审核，2:已拒绝，3:已发布，4:报名中，5:报名结束，6:已开赛，7:已结束，8:已取消)
        pxTime: ''
      },
      // 培训类型(1:分级单次培训 6:分级升级培训)，分级升级培训页面通过 extends 覆盖
      trainType: 1,

      dialogFormVisible: false,
      isCollapse: true,
      loading: null,
      gradeInfoVisible: false,
      gradeInfoDoubleVisible: false,
      updateRefereeVisible: false,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      elEnrollInfoVisible: false,
      selChangeData: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      // restaurants: [],
      PxId: '',
      cancelReson: '',

      levelOptions: [],
      sysOrgList: [],
      levelDisabled: true
    }
  },
  components: {
    AddOrUpdate,
    QueryView,
    ElEnrollInfo,
    updateClassCount
  },
  created () {

  },
  mounted () {
    this.getDataList()
    this.initCity()
    console.log(new Date('2019-11-11'.replace(/-/, '/')).getTime() > new Date().getTime())
    console.log(new Date().getTime())
  },
  methods: {
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },

    // type：1:参训; 2:取消 3:结束
    releaseClick (row, type) {
      if (type == 1) {
        this.elEnrollInfoVisible = true
        this.$nextTick(() => {
          this.$refs.elEnrollInfo.init(row)
        })
      } else if (type == 2) {
        this.PxId = row.id
        this.dialogFormVisible = true
      } else if (type == 3) {
        this.overPx(row.id)
      } else if (type == 4) { // 修改班级人数
        this.$refs.updateClassCount_ref.init(row.id, row.classCount, row.joinCount)
      }
    },
    cancelClose () {
      this.dialogFormVisible = false
      this.cancelReson = ''
    },
    //取消培训
    cancelPx () {
      this.$http({
        url: this.$http.adornUrl(`/frFranchiseFeeRecord/getIsPrePay/` + this.PxId),
        method: 'get'
      }).then(e => {
        if (e.code === 0) {
          let info = '是否取消比赛？'
          if (e.prePay) {
            info = '是否取消比赛，并退回加盟费至原账户？'
          }
          this.$confirm(info, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.$http({
              url: this.$http.adornUrl('/pxTrain/cancelTrain'),
              method: 'post',
              data: {
                id: this.PxId,
                content: this.cancelReson
              }
            }).then(e => {
              if (e.code === 0) {
                this.dialogFormVisible = false
                this.cancelReson = ''
                this.getDataList()
                this.$message.success('操作成功！')
              } else {
                this.$message.error('操作失败！')
                this.cancelReson = ''
              }
            })
          }).catch(() => {
            this.$message.info('已取消')
            this.dialogFormVisible = false
          })
        } else {
          this.$message.error('操作失败！')
          this.cancelReson = ''
        }
      })
    },
    //结束培训
    overPx (id) {
      this.$confirm('确定结束培训？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/pxTrain/overTrain/' + id),
          method: 'post'
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message.info('已取消！')
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //type 1:查看 2:审核发布
    queryHandle (id, type) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, type)
      })
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件 flagType:1:新增 2:修改 3:复制并新建
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        //新增培训类型(1:单次 2：整期 3：青少年 4：个人定制化 5：团体定制化
        this.$refs.addOrUpdate.init(id, flagType, this.trainType)
      })
    },
    //推荐或取消推荐
    recommend (id, type) {
      let tips = type == 0 ? '确定取消推荐？' : '确定推荐？'
      let param = {
        id: id,
        recommend: type == 0 ? 0 : 1
      }
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/pxTrain/updateRecommend'),
          method: 'post',
          data: param
        }).then(e => {
          if (e.code === 0) {
            this.$message.success('操作成功！')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message.info('已取消！')
      })
    },

    getDataList () {
      this.dataListLoading = true
      let applyStrTime = ''
      let applyEndTime = ''
      if (this.dataForm.pxTime) {
        if (this.dataForm.pxTime.length > 0) {
          applyStrTime = this.dataForm.pxTime[0]
          applyEndTime = this.dataForm.pxTime[1]
        }
      }
      this.$http({
        url: this.$http.adornUrl('/pxTrain/list'),
        method: 'post',
        // params: this.$http.adornParams
        data: {
          trainCode: this.dataForm.trainCode,
          name: this.dataForm.pxName,
          orgId: this.dataForm.orgId,
          level: this.dataForm.level,
          applyStrTime: applyStrTime,
          applyEndTime: applyEndTime,
          state: this.dataForm.state,
          type: this.trainType,
          page: this.pageIndex,
          limit: this.pageSize

        }
      }).then(data => {
        if (data && data.code === 0) {
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    changeItem (value) {
      this.dataForm.level = ''
      if (value.length > 0) {
        this.levelDisabled = false
        this.placeholderLevel = '请选择'
        if (value == '1') {
          this.levelOptions = this.levelOptionsOne
        }
        if (value == '2') {
          this.levelOptions = this.levelOptionsTwo
        }
      } else {
        this.levelDisabled = true
        this.placeholderLevel = '必须先选择比赛项目'
        this.levelOptions = []
      }
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    },
    //勾选列表事件
    selectionChangeHandle (val) {
      this.selChangeData = val
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}
</style>